const initialState = {
    songs: [],
    status: "idle"
  };

export default initialState;